export default __webpack_public_path__ + "static/media/remove-life-event-button.39d4f7f2.svg";